import { getRuntimeConfigValue } from '@common/next-runtime-config';
import { getSiteIdFromHost } from '@common/site-manager';

/*
 - 'TEAM_{조직명}'(팀, 파트 등등) 으로 지정하여 사용
 - grafana에서 필터하는 용도로 message에 타 조직명 포함되는 케이스 대비하여 'TEAM_' 포함하여 정의
*/
export enum Team {
  TEAM_COC = 'TEAM_COC',
  TEAM_DNCFE = 'TEAM_DNCFE',
  COMMON = 'COMMON',
}

export enum CustomLogKind {
  CART_PRODUCT_ID_NOT_EXIST = 'CART_PRODUCT_ID_NOT_EXIST',
  BRIDGE_SCREEN_ERROR = 'BRIDGE_SCREEN_ERROR',
  POST_CODE_FALLBACK = 'POST_CODE_FALLBACK',
  ORDER_SEARCH_FAILED = 'ORDER_SEARCH_FAILED',
  CLAIM_SEARCH_FAILED = 'CLAIM_SEARCH_FAILED',
  IMAGE_UPLOAD_FAILED = 'IMAGE_UPLOAD_FAILED',
  MARKETING_LOG_FAILED = 'MARKETING_LOG_FAILED',
  GOTO_PDP_FAILED = 'GOTO_PDP_FAILED',
  ORDERER_NAME_MISSING = 'ORDERER_NAME_MISSING',
  ORDERER_NAME_MISSING_AUTHENTICATION_SUCCESS = 'ORDERER_NAME_MISSING_AUTHENTICATION_SUCCESS',
  ORDERER_NAME_MISSING_PURCHASE_CLICK = 'ORDERER_NAME_MISSING_PURCHASE_CLICK',
  AUTHENTICATION_SUCCESS_ALL = 'AUTHENTICATION_SUCCESS_ALL',
  UNKNOWN = 'UNKNOWN',
}

export enum CustomLogType {
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
}

export interface CustomLogOptions {
  kind?: CustomLogKind;
  type?: CustomLogType;
}

/**
 * bifrost에 custom-log 전송
 * @param message 로그 메시지
 * @param team TEAM_{조직명}
 * @param options 추가 설정
 */
export const sendCustomLog = async (
  message: string,
  team: Team = Team.COMMON,
  { kind = CustomLogKind.UNKNOWN, type = CustomLogType.INFO }: CustomLogOptions = {},
) => {
  try {
    const site_id = getSiteIdFromHost();
    const bifrost_url = getRuntimeConfigValue('apiConsumerBaseUrl', site_id);

    const params = new URLSearchParams({
      site_id,
      team,
      message,
      custom_log_kind: kind,
      custom_log_type: type,
    });

    await fetch(`${bifrost_url}/custom-log?${params.toString()}`, {
      method: 'GET',
      credentials: 'include',
    });
  } catch (e) {
    console.error(e);
  }
};

/**
 * MEMO:
 * URL query parameters에서 TossUserNo 값을 가져오거나
 * userAgent에서 TossUserNo 값을 가져오는 함수
 *
 * 토스 3탭 메인에서는 custom ua 주입이 불가해서 qs로 받아올 수 밖에 없는 구조라 더블체크한다.
 * @returns {string|null} tossUserNo 값 또는 null
 */
export function getTossUserNoValue(): string | null {
  try {
    let value: string | null = null;

    // 1. Query Parameter에서 tossUser 값을 찾는다.
    if (typeof window !== 'undefined' && window.location && window.location.search) {
      const params = new URLSearchParams(window.location.search);
      if (params.has('tossUser')) {
        value = params.get('tossUser');
      }
    }

    // 2. Query Parameter에서 못 찾았으면 userAgent에서 찾는다.
    if (!value && typeof navigator !== 'undefined' && navigator.userAgent) {
      const match = navigator.userAgent.match(/TossUser\/([^\s]+)/);
      if (match && match[1]) {
        value = match[1];
      }
    }

    return value;
  } catch {
    return null;
  }
}
